@use "ui/styles/colorsOld";

.popoverMenuWrapper {
  z-index: 1;
  position: relative;
  padding-right: 8px !important;

  &.disabled {
    cursor: not-allowed !important;
    color: colorsOld.$stoneLight !important;

    &:hover {
      background-color: colorsOld.$white !important;
    }
  }

  :global {
    .menu {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
  }
}

.popoverMenu {
  position: absolute;
  background-color: colorsOld.$white;
  border-radius: 4px;
  overflow-y: auto;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  padding: 11px 0;
  border: 1px solid colorsOld.$stoneLightX1;

  > * {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    text-decoration: none;
    padding: 9px 18px;
    min-width: 130px;
    font-size: 12px;
    text-align: left;
    cursor: pointer;
    color: colorsOld.$stoneDark;
    background-color: colorsOld.$white;
    transition: background-color 0.2s;

    &:hover {
      background-color: colorsOld.$stoneLightX4;
    }

    &.disabled {
      pointer-events: none;
      cursor: default;
    }
  }

  :global {
    .disabled {
      cursor: default;
      color: colorsOld.$stoneLight;

      &:hover {
        background-color: colorsOld.$white;
      }
    }
  }
}

.bottom {
  left: 42px;
  margin-top: 5px;
}

.left {
  top: -12px;
  right: 100%;
}

.top {
  top: 0;

  .popoverMenu {
    bottom: 0
  }
}

.bottom-right {
  margin-top: 5px;
  right: 0;
}